const robotActive = () => {
  const active = {
    // 轨迹
    track: () => {},
    detail: () => {
    },
    location: () => {},
    mileage: () => {},
    alarmDetail: () => {
    },
    onlineDetail: () => {},
  }

  return active;
}
export let checkAiRobot = (userInfo) => {
  let checkLogin = false;
  if(window.location.pathname !== '/login'){
    if(userInfo.sid === null) return false;
    checkLogin = true;
    let aiUrl = 'https://dify.car900.com:7752';
    let aiScriptUrl = 'https://dev.car900.com:9907/embed.js';
    let staticUrl = aiScriptUrl.split('embed.js');
    
    window.aiChatbotConfig = {
      botName: 'AI智能助手',    // 设置机器人名称
      baseUrl:aiUrl,  // 设置后端API地址,
      userId:userInfo.id, // 设置用户ID
      productName: 'simCardClient',
      robotHeaderUrl: 'https://test.bsjiot.com/oss/img/card/homePage/2025-06-03/683e4b0860b25d8653688354.png',
      staticUrl: staticUrl[0],
      appType:'simCard',
      chatStyle: {
        chatRight: '30px',
        chatBottom: '50px',
      },
      onTextButtonClick: (result) => {
        const { type,data } = result;
        const active = robotActive(data);
        try{
          active[type]();
        }catch(e){
          console.log(result);
        }
      },
      sessionId:userInfo.sid, // 设置会话ID,
      faqList:[
        '怎样区分2G卡和4G卡？',
        'C端续费流程？',
        '小博物联使用说明书？',
        '客户端使用说明书？',
        '查询XXXXX卡信息（实际查询需将“XXXXX”替换为真实卡号或者iccid）',
        '解绑XXXX（实际查询需将“XXXX”替换为真实卡号或者iccid且只支持惠州联通/联通卡）',
        '重置/刷新XXXXXX',
      ],
      onReady: () => {
        const chatbotWrapper = document.querySelector('.chatbot-wrapper');
        chatbotWrapper.style.bottom = '150px';
      }
    }

    let script = document.createElement('script');
    script.type = 'text/javascript'
    script.defer = true;
    script.src = aiScriptUrl;
    document.head.appendChild(script);
  }
}
